import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
/**
 * fc-radioåé
 * 
 * åéæ¡ã
 * 
 * ç¨äºå¨å¤ä¸ªå¤éé¡¹ä¸­éä¸­åä¸ªç¶æã
 * 
 * åSelectçåºå«æ¯ï¼Radioææéé¡¹é»è®¤å¯è§ï¼æ¹ä¾¿ç¨æ·å¨æ¯è¾ä¸­éæ©ï¼å æ­¤éé¡¹ä¸å®è¿å¤ã
 * 
 */
@Component({
    selector: 'fc-radio',
    template: `
<label (click)="click($event,fcOption[0][fcValueCode])" [ngClass]="{'fc-readonly':_readonly ===true,'fc-radio-small':fcSize === 'small','fc-radio-default':fcSize === 'default','fc-radio-large':fcSize === 'large'}"
    nz-radio [nzDisabled]="_disabled" *ngIf="fcOption!==undefined&&fcOption.length===1&&fcType==='radio'&&fcShowLabel==='N'" [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzValue]="fcOption[0][fcValueCode]">
    {{fcOption[0][fcLabelCode]}}
</label>
<label (click)="click($event,fcOption[0][fcValueCode])" [ngClass]="{'fc-readonly':_readonly ===true,'fc-radio-small':fcSize === 'small','fc-radio-default':fcSize === 'default','fc-radio-large':fcSize === 'large'}"
 nz-radio-button [nzDisabled]="_disabled"
 *ngIf="fcOption!==undefined&&fcOption.length===1&&fcType==='button'&&fcShowLabel==='N'" [(ngModel)]="innerValue" (ngModelChange)="valueOnChange($event)" [nzValue]="fcOption[0][fcValueCode]">
    <span>{{fcOption[0][fcLabelCode]}}</span>
</label>
<nz-radio-group [ngClass]="{'fc-readonly':_readonly ===true,'fc-vertical':_mode===true}" [(ngModel)]="innerValue" (ngModelChange)="valueOnChange($event)" [nzSize]="fcSize" *ngIf="fcOption!==undefined&&fcOption.length>1&&fcType==='radio'&&fcShowLabel==='N'">
    <label (click)="click($event,option[fcValueCode])"  nz-radio [nzDisabled]="_disabled" *ngFor="let option of fcOption" [nzValue]="option[fcValueCode]">
        <span>{{option[fcLabelCode]}}</span>
    </label>
</nz-radio-group>
<nz-radio-group [ngClass]="{'fc-readonly':_readonly ===true,'fc-vertical':_mode===true}" [(ngModel)]="innerValue" (ngModelChange)="valueOnChange($event)" [nzSize]="fcSize" *ngIf="fcOption!==undefined&&fcOption.length>1&&fcType==='button'&&fcShowLabel==='N'">
    <label (click)="click($event,option[fcValueCode])"  nz-radio-button [nzDisabled]="_disabled" *ngFor="let option of fcOption" [nzValue]="option[fcValueCode]">
        <span>{{option[fcLabelCode]}}</span>
    </label>
</nz-radio-group>
<div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <label (click)="click($event,fcOption[0][fcValueCode])"  [ngClass]="{'fc-readonly':_readonly ===true,'fc-radio-small':fcSize === 'small','fc-radio-default':fcSize === 'default','fc-radio-large':fcSize === 'large'}" 
                nz-radio [nzDisabled]="_disabled" *ngIf="fcOption!==undefined&&fcOption.length===1&&fcType==='radio'"
                 [(ngModel)]="innerValue" (ngModelChange)="valueOnChange($event)" [nzValue]="fcOption[0][fcValueCode]">
                    <span>{{fcOption[0][fcLabelCode]}}</span>
            </label>
            <label (click)="click($event,fcOption[0][fcValueCode])" [ngClass]="{'fc-readonly':_readonly ===true,'fc-radio-small':fcSize === 'small','fc-radio-default':fcSize === 'default','fc-radio-large':fcSize === 'large'}" nz-radio-button *ngIf="fcOption!==undefined&&fcOption.length===1&&fcType==='button'" [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzValue]="fcOption[0][fcValueCode]" [nzDisabled]="_disabled">
                <span>{{fcOption[0][fcLabelCode]}}</span>
            </label>
            <nz-radio-group [ngClass]="{'fc-readonly':_readonly ===true,'fc-vertical':_mode===true}" [(ngModel)]="innerValue" (ngModelChange)="valueOnChange($event)" [nzSize]="fcSize" *ngIf="fcOption!==undefined&&fcOption.length>1&&fcType==='radio'">
                <label (click)="click($event,option[fcValueCode])" nz-radio [nzDisabled]="_disabled" *ngFor="let option of fcOption" [nzValue]="option[fcValueCode]">
                    <span>{{option[fcLabelCode]}}</span>
                </label>
            </nz-radio-group>
            <nz-radio-group [ngClass]="{'fc-readonly':_readonly ===true,'fc-vertical':_mode===true}" [(ngModel)]="innerValue" (ngModelChange)="valueOnChange($event)" [nzSize]="fcSize" *ngIf="fcOption!==undefined&&fcOption.length>1&&fcType==='button'">
                <label (click)="click($event,option[fcValueCode])" nz-radio-button [nzDisabled]="_disabled" *ngFor="let option of fcOption" [nzValue]="option[fcValueCode]">
                    <span>{{option[fcLabelCode]}}</span>
                </label>
            </nz-radio-group>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div>
    </div>
    `,
    styles: [`
    .fc-readonly {
        pointer-events: none;
        color:Â #b2b9bd;
    }
    :host ::ng-deep  .fc-readonly .ant-radio-checked ng-untouched ng-pristine ng-valid{
        color:#ccc;
    }
    :host ::ng-deep  .fc-readonly .ant-radio-checked .ant-radio-inner{
        border-color:#ccc;
    }
    :host ::ng-deep .fc-readonly .ant-radio-inner:after{
        background:#f5f5f5;
    } 
    :host ::ng-deep .fc-readonly .ant-radio-wrapper{
        border-color:#ccc;
    }
    .form-explain {
        position:relative;
    }
    .explain{
        white-space: nowrap;
        position:absolute;
        right: -1px;
        bottom: 24px;
        z-index:10;
    }
    .explain-inner {
        position:relative;
        color:red;
    }
    .explain-inner:after{
        content: '';
        width: 10px;
        height: 12px;
        display: block;
        background-color: #ffffff;
        border-right: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: absolute;
        bottom: -6px;
        right: 12px;
        transform: rotate(45deg);
        z-index: 0;
    }
    .explain-tips{
        padding: 0px 10px;
        background-color: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        font-size: 12px;
        height: 30px;
        line-height: 28px;
    }
    :host ::ng-deep .ng-untouched ng-pristine ng-valid{
        width:100%;
    }
    :host ::ng-deep .fc-vertical .ant-radio-wrapper {
        display: block;
    }
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcradioComponent),
        multi: true
    }]
})
export class FcradioComponent extends FcinputComponent {
    lastValue:any;
    /**æ¾ç¤ºæ¨¡å¼*/
    @Input()
    fcMode: string;
    _mode: boolean;
    /** åéå¼*/
    @Input()
    fcOption: any[] = [];
    /**labelå­æ®µåç§°*/
    @Input()
    fcLabelCode: string;
    /**valueå­æ®µåç§°*/
    @Input()
    fcValueCode: string;
    /**disabledå­æ®µåç§°*/
    @Input()
    _disabledCode: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-radio');
        if (this.fcType === undefined) {
            this.fcType = 'radio';
        }
        if(this.fcShowLabel===undefined){
            this.fcShowLabel = "Y";
        }
    }
    _afterParentInit() {
        if (this.fcOption === undefined) {
            this.fcOption = [];
        }
        if (this.fcLabelCode === undefined) {
            this.fcLabelCode = 'label';
        }
        if (this.fcValueCode === undefined) {
            this.fcValueCode = 'value';
        }
        if (this._disabledCode === undefined) {
            this._disabledCode = 'disabled';
        }
        /**æ¨¡å¼*/
        if (this.fcMode === "Y") {
            this._mode = true;
        } else {
            this._mode = false;
        }
        if (this.fcOption && this.fcOption instanceof Array) {
            this.fcOption.forEach(element => {
                if (!element.hasOwnProperty(this._disabledCode)) {
                    element[this._disabledCode] = false;
                }
            });
        }
        /**æ¯å¦ç¦ç¨*/
        if (this.fcDisabled === 'Y') {
            this._disabled = true;
        }else{
            this._disabled = false;
        }
        /**æ¯å¦åªè®*/
        if (this.fcReadonly === 'Y') {
            this._readonly = true;
        }else{
            this._readonly = false;
        }
    }
    click($event,value){
        $event.value = value;
        this.event('click',$event);
        this.lastValue = this.innerValue;
    }
    valueOnChange(selectOptions: any):void{
        this.checkValidator(selectOptions);
        this.onChangeCallback(selectOptions);
    }
}
